/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {IConfigureUserData} from "../../../containers/pages/admin/AddUser/ConfigureUser/styles";
import {IAddUserTableRow} from "../../../containers/pages/admin/AddUser/SearchUser/AddUserTable";

interface IState {
  isAddUserDialogOpen: boolean
  isRoadCurvaturePopupVisible: boolean
  isObjectsPopupVisible: boolean
  isAddExistingUserDialogVisible: boolean
  isConfigureUserVisible: boolean
  isConfirmAddUserDialogVisible: boolean,
  configureUserData: IConfigureUserData
  searchUserState: ISearchUserState,
  refreshTable: number,
  configureOrigin: TConfigureOrigin
  isNewUser: boolean | null
}

interface ISearchUserState {
  addUserTableRows: IAddUserTableRow[]
  searchValue: string
}

type TConfigureOrigin = 'edit' | 'search' | null
const initialState: IState = {
  isAddUserDialogOpen: false,
  isConfigureUserVisible: false,
  isRoadCurvaturePopupVisible: false,
  isObjectsPopupVisible: false,
  isAddExistingUserDialogVisible: false,
  isConfirmAddUserDialogVisible: false,
  configureUserData: {} as IConfigureUserData,
  searchUserState: {
    addUserTableRows: [],
    searchValue: ''
  },
  refreshTable: 0,
  configureOrigin: null,
  isNewUser: null
} as IState

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    clearState: () => initialState,
    setIsAddUserDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.isAddUserDialogOpen = action.payload
      if (action.payload == false) {
        state.refreshTable += 1
      }
    },
    setIsRoadCurvaturePopupVisible: (state, action: PayloadAction<boolean>) => void (state.isRoadCurvaturePopupVisible = action.payload),
    setIsObjectsPopupVisible: (state, action: PayloadAction<boolean>) => void (state.isObjectsPopupVisible = action.payload),
    setIsAddExistingUserDialogVisible: (state, action: PayloadAction<boolean>) => void (state.isAddExistingUserDialogVisible = action.payload),
    setIsConfigureUserVisible: (state, action: PayloadAction<boolean>) => void (state.isConfigureUserVisible = action.payload),
    setConfigureUserData: (state, action: PayloadAction<IConfigureUserData>) => void (state.configureUserData = action.payload),
    setAddUserTableRows: (state, action: PayloadAction<IAddUserTableRow[]>) => void (state.searchUserState.addUserTableRows = action.payload),
    setSearchValue: (state, action: PayloadAction<string>) => void (state.searchUserState.searchValue = action.payload),
    setConfigureOrigin: (state, action: PayloadAction<TConfigureOrigin>) => void (state.configureOrigin = action.payload),
    setIsNewUser: (state, action: PayloadAction<boolean>) => void (state.isNewUser = action.payload),
    setIsConfirmAddUserDialogVisible: (state, action: PayloadAction<boolean>) => {state.isConfirmAddUserDialogVisible = action.payload},
  }
})

const selectUserState = (state: RootState) => state.userSlice

const {actions, reducer} = userSlice
export {
  selectUserState
}
export const {
  clearState,
  setIsObjectsPopupVisible,
  setIsRoadCurvaturePopupVisible,
  setIsAddExistingUserDialogVisible,
  setIsConfigureUserVisible,
  setConfigureUserData,
  setIsAddUserDialogOpen,
  setIsConfirmAddUserDialogVisible,
  setAddUserTableRows,
  setSearchValue,
  setConfigureOrigin,
  setIsNewUser
} = actions

export default reducer
